import { Layout, Frame, Button, Page, Toast } from '@shopify/polaris';

import SearchCustomer from './Search.jsx';
import {useState, useEffect, useCallback} from 'react';
import { useHistory } from 'react-router-dom';
import CustomerForm from './Form.jsx';
import Api from '../../helpers/api';

const Customers = () => {

    const history = useHistory();
    const [customer, setCustomer] = useState(null);
    const [creating, setCreating] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [toast, setToast] = useState({
        active: false,
        message: ''
    });

    const toastMarkup = toast.active ? (
        <Toast content={toast.message} duration={3000} onDismiss={() => { setToast({ message: '', active: false }) }} />
    ) : null;


    const assignCustomer = (customer) => {
        history.push(`/customers/${customer.id}`);
    }

    const pageTitle = () => {
        if (updating) {
            return 'Edit Customer';
        } else if (creating) {
            return 'Create New Customer';
        } else {
            return 'Customers';
        }
    }

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const success = urlParams.get('draft_success');

        if ( success ) {
            setToast({ message: 'The draft order was created', active: true })
        }
    }, []);

    return (
        <Frame>
            <Page
                title={pageTitle()}
                primaryAction={
                    (!creating && !updating) ? <Button primary onClick={() => { setCreating(true) }}>New Customer</Button>
                        : <Button onClick={() => { setCreating(false); setUpdating(false) }}>Go Back</Button>
                }
            >
                {(creating || updating) ? (
                    <Layout>
                        <Layout.Section>
                            <CustomerForm
                                customer={customer}
                                updating={false}
                                onCustomerCreated={customer => {
                                    assignCustomer(customer);
                                    setToast({ active: true, message: 'Customer Created' });
                                }}
                                creating={creating}
                            />
                        </Layout.Section>
                    </Layout>
                ) : (
                    <Layout>
                        <Layout.Section>
                            {<SearchCustomer onCustomerSelect={(customer) => {
                                assignCustomer(customer);
                            }} />}
                        </Layout.Section>
                    </Layout>
                )}
            </Page>
            {toastMarkup}
        </Frame>
    );
}


export default Customers;
